import React, { useState } from 'react'
import { Col, FlexboxGrid, Panel, Row, Table } from 'rsuite'
import InputForm from '../../components/forms/input/InputForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import { Controller, useForm } from 'react-hook-form'
import notification from '../../utils/notification'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { cloneDeep, isEmpty } from 'lodash-es'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { exportAssessmentReport, searchAssessmentReport } from '../../redux/actions/assessment'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import { downloadFile } from '../../utils/fileUtil'
import moment from 'moment'
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../constants/date'
import InputDateForm from '../../components/forms/input/InputDateForm'

export default function AssessmentReportDynamicWidgets({ schema: _schema, type, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [formSchema, setFormSchema] = useState(_schema)
  const [isRefash, setIsRefash] = useState(false)
  const [datas, setData] = useState(_schema?.resultData?.values || [])
  const [totalSize, setTotalSize] = useState(_schema?.resultData?.total || 0)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState()
  const [searchData, setSearchData] = useState({})
  const [request, setRequest] = useState({
    pageNum: 1,
    pageSize: displayLength,
  })

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const handleSearch = async (req) => {
    setLoading(true)
    try {
      // console.log('req : ', req)

      const response = await searchAssessmentReport(req, type)

      // console.log('response ', response)

      if (response) {
        setData(response.values || [])
        setTotalSize(response.total || 0)

        onRefash()
      } else {
        setData([])
        setTotalSize(0)
        onRefash()
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setLoading(false)
  }

  const handleExport = async () => {
    setLoading(true)
    try {
      // console.log('req : ', req)

      const file = await exportAssessmentReport(request, type)

      if (file) {
        downloadFile(
          file,
          file.name || `${formSchema.header}_${moment().format(DATE_TIME_FORMAT)}.xlsx`
        )
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setLoading(false)
  }

  const onSubmit = (data) => {
    // console.log('onSubmit:', data)

    let req = {
      pageNum: 1,
      pageSize: displayLength,
    }

    var parameters = []

    if (data) {
      formSchema?.searchForm?.forEach((e) => {
        if (!isEmpty(e.inputType)) {
          parameters.push({ key: e.name, value: data[e.name] })
        }
      })
    }

    req['parameters'] = parameters

    console.log('req : ', req)

    setPage(1)
    setRequest(req)
    handleSearch(req)
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const handleChangePage = (dataKey) => {
    // console.log('handleChangePage page', dataKey)

    setPage(dataKey)

    let req = cloneDeep(request)

    req['pageNum'] = dataKey

    setRequest(req)
    handleSearch(req)
  }

  const handleChangeLength = (dataKey) => {
    // console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)

    let req = cloneDeep(request)
    req['pageNum'] = 1
    req['pageSize'] = dataKey

    setRequest(req)
    handleSearch(req)
  }

  const onChangeInput = (key, value) => {
    var data = cloneDeep(searchData)

    data[key] = value
    setSearchData(data)
  }

  return (
    <Panel
      bordered
      // key={data.id}
      style={{ marginBottom: 10, marginTop: 10 }}
      collapsible
      defaultExpanded
      header={formSchema.header}
    >
      {!isRefash && (
        <>
          {formSchema.searchForm && (
            <Panel bordered style={{ marginBottom: 10, marginTop: -10 }} header={'ค้นหา'}>
              <FlexboxGrid style={{ marginTop: -10 }}>
                {formSchema.searchForm?.map((e) => {
                  let obj

                  switch (e.inputType) {
                    case '1':
                      obj = (
                        <InputForm
                          schema={e}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          value={searchData[e.name]}
                          onChange={(value) => {
                            onChangeInput(e.name, value)
                          }}
                        />
                      )
                      break
                    case '2':
                      obj = (
                        <InputForm
                          isInputNumber
                          schema={e}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          value={searchData[e.name]}
                          onChange={(value) => {
                            onChangeInput(e.name, value)
                          }}
                        />
                      )
                      break
                    case '3':
                      obj = (
                        <InputSelectForm
                          schema={e}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          value={searchData[e.name]}
                          onChange={(value) => {
                            onChangeInput(e.name, value)
                          }}
                        />
                      )
                      break
                    case '4':
                      obj = (
                        <InputDateForm
                          schema={e}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          value={searchData[e.name]}
                          onChange={(value) => {
                            onChangeInput(e.name, moment(value).format(DATE_FORMAT))
                          }}
                        />
                      )
                      break
                    default:
                      break
                  }

                  return (
                    <FlexboxGrid.Item
                      componentClass={Col}
                      colspan={24}
                      lg={12}
                      md={12}
                      sm={24}
                      xs={24}
                    >
                      {obj}
                    </FlexboxGrid.Item>
                  )
                })}
              </FlexboxGrid>

              <hr />
              <Row style={{ textAlign: 'right' }}>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <SaveButton
                    children="คันหา"
                    icon="search"
                    //onClick={handleSubmit(onSubmit)}
                    onClick={() => {
                      onSubmit(searchData)
                    }}
                    disabled={loading}
                  />

                  <CancelButton
                    children="ยกเลิก"
                    onClick={() => {
                      setSearchData({})
                      onSubmit()
                    }}
                  />
                </Col>
              </Row>
            </Panel>
          )}

          <Row style={{ textAlign: 'right', marginBottom: 10 }}>
            <Col>
              <ViewButton
                icon="print"
                children="Exprot Excel"
                disabled={datas?.length < 1}
                onClick={handleExport}
              />
            </Col>
          </Row>
          <Table
            wordWrap
            rowKey="rowNum"
            // height={400}
            autoHeight
            data={datas || []}
            loading={loading}
            headerHeight={75}

            // headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
          >
            <Column align="center" width={100} fixed>
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell dataKey="rowNum" />
            </Column>

            {formSchema.resultData?.columnConfig?.map((item) => {
              if (item.children?.length > 0) {
                return item.children.map((e, index) => {
                  return (
                    <Column width={e.width || 150} align={item.align || ''} resizable>
                      <HeaderCell>{e.label}</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          var data = rowData[item.key]

                          return <>{data ? data[index] : ''}</>
                        }}
                      </Cell>
                    </Column>
                  )
                })
              } else {
                return (
                  <Column width={item.width || 150} align={item.align || ''} resizable>
                    <HeaderCell>{item.label}</HeaderCell>
                    <Cell>
                      {(rowData, index) => {
                        return rowData[item.key]
                      }}
                    </Cell>
                  </Column>
                )
              }
            })}
          </Table>
          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page || defaultPage}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total || 0} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        </>
      )}
    </Panel>
  )
}
